import './styles/applianceArchives.scss';

import { ApplianceSingle, ListingFilter } from '../components/Listing';
import React, { useEffect, useState } from 'react';

import { AppliancePageFilter } from '../components/appliance';
import { Breadcrumb } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import { FooterBanner } from '../components/Layout';
import { IAppliance } from '../interfaces';
import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import { PageTitle } from '../components/Primitives';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { graphql } from 'gatsby';
import usaFlag from '@progymedia/sbi-web-englander/src/images/backgrounds/usa-flag-background.jpg';
import usaFlagMobile from '@progymedia/sbi-web-englander/src/images/backgrounds/usa-flag-background-mobile.jpg';
import useMobileDetect from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useMobileDetect';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useProductsPricesAndCode } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/store/queries/useProductsPriceAndInventories';
import { useQueryArg } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useQueryArg';
import { useTranslation } from 'react-i18next';

export const query = graphql`
    query ($category: String!, $cmsPage: String!) {
        allProductsJson(
            filter: { category: { regex: $category }, status: { eq: "actif" } }
            sort: { attributes: { size: { values: { en_CA: DESC } } } }
        ) {
            nodes {
                id
                code
                slug {
                    en_CA
                    en_US
                    fr_CA
                }
                category
                category_localized {
                    en_CA
                    en_US
                    fr_CA
                }
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                attributes {
                    available_country {
                        name {
                            en_CA
                            en_US
                            fr_CA
                        }
                        values {
                            en_US
                            fr_CA
                            en_CA
                        }
                    }
                    PWMaSoi {
                        name {
                            en_CA
                            en_US
                            fr_CA
                        }
                        values {
                            en_US
                            fr_CA
                            en_CA
                        }
                    }
                    MaiMob {
                        values {
                            en_US
                            fr_CA
                            en_CA
                        }
                    }
                    Alcove {
                        values {
                            en_US
                            fr_CA
                            en_CA
                        }
                    }
                    Surfi {
                        name {
                            en_CA
                            en_US
                            fr_CA
                        }
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    EPA {
                        group
                        name {
                            en_CA
                            en_US
                            fr_CA
                        }
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    certifications {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    size {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
                images {
                    en_CA
                    en_US
                    fr_CA
                }
                fields {
                    ...productsFieldsImagesFragment
                }
            }
        }
        cmsPage: allProductsJson(filter: { code: { eq: $cmsPage } }) {
            nodes {
                ...cmsDataFragment
                attributes {
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        superficieLink: allProductsJson(
            filter: { code: { eq: "englander_superficie-lien" } }
        ) {
            nodes {
                code
                attributes {
                    texte_1 {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    link {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
    }
`;
export interface IFilterDefaults {
    minVal: number;
    maxArea: number;
    maxPower: number;
    maxPrice: number;
}
const filterDefaults: IFilterDefaults = {
    minVal: 0,
    maxArea: 4000,
    maxPower: 120000,
    maxPrice: 3000,
};
export default function ApplianceArchives(props: {
    data: any;
    pageContext: any;
    location: any;
}) {
    const { data, pageContext, location } = props;
    const { pagePath, category } = pageContext;
    const allProducts = data.allProductsJson.nodes;
    const cmsPage = data?.cmsPage?.nodes[0];
    const metadataAttributes = cmsPage?.attributes;
    const prodPriceCp = [
        ...useProductsPricesAndCode(
            allProducts.map((family: { code: string }) => family.code)
        ),
    ];
    const prodWithPrices = allProducts?.slice().map((prod: any) => {
        const pPrice = prodPriceCp?.[0]?.find(
            (e: { sku: string | undefined }) => e.sku === prod.code
        );
        return {
            ...prod,
            ...pPrice,
        };
    });
    const [filteredProducts, setFilteredProducts] = useState(prodWithPrices);
    const { currentLocale } = usePageLocalization();
    const metadata = {
        title: metadataAttributes?.meta_title?.values[0][currentLocale],
        description:
            metadataAttributes?.meta_description?.values[0][currentLocale],
    };
    const { t } = useTranslation('layout');
    const isMobile = useMobileDetect().isMobile();
    const isTablet = useMobileDetect().isTablet();
    const isDesktop = useMobileDetect().isDesktop();
    const [displayMobileFilter, setDisplayMobileFilter] = useState(true);
    const [priceArg] = useQueryArg('price');
    const [surfiArg] = useQueryArg('surfi');
    const [powerArg] = useQueryArg('power');
    const [installArg] = useQueryArg('install');
    const [sizeArg] = useQueryArg('size');
    const [madeInArg] = useQueryArg('madeIn');
    const [qPage] = useQueryArg('page');
    const [page, setPage] = useState(qPage ? parseInt(qPage) : 1);
    const [showSmallFilter, setShowSmallFilter] = useState(true);
    const [sort, setSort] = useQueryArg('sort');
    const powerArgArr = powerArg?.split('-');
    const [filterPowerState, setFilterPowerState] = useState(
        powerArg
            ? [
                  parseInt(
                      powerArgArr?.[0] ?? filterDefaults.minVal.toString()
                  ),
                  parseInt(
                      powerArgArr?.[1] ?? filterDefaults.maxPower.toString()
                  ),
              ]
            : [filterDefaults.minVal, filterDefaults.maxPower]
    );

    const surfiArgArr = surfiArg?.split('-');
    const [filterSurfiState, setFilterSurfiState] = useState(
        surfiArg
            ? [
                  parseInt(
                      surfiArgArr?.[0] ?? filterDefaults.minVal.toString()
                  ),
                  parseInt(
                      surfiArgArr?.[1] ?? filterDefaults.maxArea.toString()
                  ),
              ]
            : [filterDefaults.minVal, filterDefaults.maxArea]
    );

    const [filterSizeState, setFilterSizeState] = useState(sizeArg || '');
    const [filterMadeInState, setFilterMadeInState] = useState(madeInArg || '');
    const [filterPriceState, setFilterPriceState] = useState(priceArg || '');
    const [filterInstallState, setFilterInstallState] = useState(
        installArg || ''
    );

    if (location && typeof window !== 'undefined') {
        window.scrollTo(0, location?.state?.scrollPosition);
    }
    useEffect(() => {
        if (priceArg) {
            setFilterPriceState(priceArg);
        } else {
            setFilterPriceState('');
        }
        if (installArg) {
            setFilterInstallState(installArg);
        } else {
            setFilterInstallState('');
        }

        if (powerArg) {
            try {
                const args = powerArg?.split('-');
                setFilterPowerState([parseInt(args[0]), parseInt(args[1])]);
            } catch (e) {
                console.log(e);
            }
        } else {
            setFilterPowerState([
                filterDefaults.minVal,
                filterDefaults.maxPower,
            ]);
        }

        if (surfiArg) {
            try {
                const args = surfiArg?.split('-');
                setFilterSurfiState([parseInt(args[0]), parseInt(args[1])]);
            } catch (e) {
                console.log(e);
            }
        } else {
            setFilterSurfiState([
                filterDefaults.minVal,
                filterDefaults.maxArea,
            ]);
        }

        if (sizeArg) {
            setFilterSizeState(sizeArg);
        } else {
            setFilterSizeState('');
        }

        if (madeInArg) {
            setFilterMadeInState(madeInArg);
        } else {
            setFilterMadeInState('');
        }

        setPage(page);
    }, [installArg, page, powerArg, priceArg, madeInArg, sizeArg, surfiArg]);

    useEffect(() => {
        if (isMobile) {
            setShowSmallFilter(false);
        }
        if (isTablet || isDesktop) {
            setShowSmallFilter(true);
        }
    }, [isDesktop, isMobile, isTablet]);

    // To render empty ApplianceSingle for layout
    const missingEmptyProductsNumber = (filteredProducts.length % 3) - 1;
    const missingEmptyProducts = [];
    for (let i = 0; i < missingEmptyProductsNumber; i++) {
        missingEmptyProducts.push(<div className='appliance-single empty' />);
    }

    const [footerImg, setFooterImg] = useState(
        isMobile ? usaFlagMobile : usaFlag
    );

    useEffect(() => {
        if (isMobile) {
            setFooterImg(usaFlagMobile);
        } else {
            setFooterImg(usaFlag);
        }
    }, [isMobile]);

    return (
        <Layout>
            <SEO title={metadata?.title} description={metadata?.description} />

            <Breadcrumb
                className='appliance-listing-breadcrumb'
                elements={[
                    { link: '/', name: t('layout:appliance.home') },
                    { link: '', name: cmsPage?.title[currentLocale] },
                ]}
            />
            <div className='appliance-archive-page'>
                {!isMobile && (
                    <AppliancePageFilter
                        filteredProducts={filteredProducts}
                        allProducts={prodWithPrices}
                        setFilteredProducts={setFilteredProducts}
                        filterDefaults={filterDefaults}
                        path={pagePath}
                        filterSurfiState={filterSurfiState}
                        filterPowerState={filterPowerState}
                        filterPriceState={filterPriceState}
                        filterInstallState={filterInstallState}
                        filterSizeState={filterSizeState}
                        filterMadeInState={filterMadeInState}
                        powerArg={powerArg}
                        surfiArg={surfiArg}
                        priceArg={priceArg}
                        installArg={installArg}
                        sizeArg={sizeArg}
                        madeInArg={madeInArg}
                        applianceCategory={category}
                        surfiLink={data.superficieLink?.nodes?.[0]?.attributes}
                        setPage={setPage}
                    />
                )}

                <div className='archive-listing-container'>
                    <PageTitle
                        title={cmsPage?.title[currentLocale]}
                        description={
                            cmsPage?.attributes?.content?.values?.[0][
                                currentLocale
                            ]
                        }
                    >
                        <ListingFilter
                            filteredProducts={filteredProducts}
                            setFilteredProducts={setFilteredProducts}
                            setPage={setPage}
                            priceAndCode={prodPriceCp}
                            setSort={setSort}
                            sort={sort}
                            showSmallFilter={showSmallFilter}
                            setShowSmallFilter={setShowSmallFilter}
                            displayMobileFilter={displayMobileFilter}
                            setDisplayMobileFilter={setDisplayMobileFilter}
                        />
                    </PageTitle>
                    {isMobile && displayMobileFilter && (
                        <AppliancePageFilter
                            filteredProducts={filteredProducts}
                            allProducts={prodWithPrices}
                            setFilteredProducts={setFilteredProducts}
                            filterDefaults={filterDefaults}
                            path={pagePath}
                            filterSurfiState={filterSurfiState}
                            filterPowerState={filterPowerState}
                            filterPriceState={filterPriceState}
                            filterInstallState={filterInstallState}
                            filterSizeState={filterSizeState}
                            filterMadeInState={filterMadeInState}
                            powerArg={powerArg}
                            surfiArg={surfiArg}
                            priceArg={priceArg}
                            installArg={installArg}
                            sizeArg={sizeArg}
                            madeInArg={madeInArg}
                            applianceCategory={category}
                            surfiLink={
                                data.superficieLink?.nodes?.[0]?.attributes
                            }
                            setPage={setPage}
                        />
                    )}
                    <div className='archive-listing'>
                        <span className='results'>
                            {filteredProducts.length === 0 ? (
                                t('boutik:archives.no-result')
                            ) : (
                                <span>
                                    {`${filteredProducts.length} `}
                                    {filteredProducts.length > 1
                                        ? t('boutik:archives.results')
                                        : t('boutik:archives.result')}
                                </span>
                            )}
                        </span>
                        {filteredProducts?.map((appliance: IAppliance) => (
                            <ApplianceSingle
                                appliance={appliance}
                                key={appliance.code}
                            />
                        ))}
                        {filteredProducts.length == 1 && (
                            <>
                                <div className='appliance-single empty' />
                                <div className='appliance-single empty' />
                            </>
                        )}
                        {filteredProducts.length == 2 && (
                            <>
                                <div className='appliance-single empty' />
                            </>
                        )}

                        {missingEmptyProducts?.map(
                            (emptyApplianceSingle) => emptyApplianceSingle
                        )}
                    </div>
                </div>
            </div>
            <FooterBanner
                image={footerImg}
                text={t('footer.proudly-made-us')}
            />
        </Layout>
    );
}
